import React from 'react';

const OverviewLayoutAside: React.FC = ({ children }) => <>{children}</>;

export default OverviewLayoutAside;
